import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  OPEN_FLOW_LINK: `${cleanedFilename(__filename)}-open-flow-link`,
};
